import { MatchHeight } from "@plugins";
import { elementScrollIntoView } from "seamless-scroll-polyfill";

class ReadyToHelpCompressor {
    constructor(element) {
        this.elem = element;
        this.textsToCompress = [];
        this.controlButtons = [];

        this._init();
    }

    _init() {
        if (!this.elem) return;

        this._findTextsToCompress();
        this._initCompressor();
    }

    _findTextsToCompress() {
        const textsToCompress = this.elem.querySelectorAll("[data-lines-limiter]");

        if (textsToCompress) {
            textsToCompress.forEach((text) => {
                const lineLimiterValue = Number(text.dataset.linesLimiter);
                const textHeight = text.offsetHeight;
                const textComputedStyles = window.getComputedStyle(text);
                const textLineHeightProperty = parseInt(textComputedStyles.getPropertyValue("line-height"), 10);

                if (textHeight > textLineHeightProperty * lineLimiterValue) {
                    this.textsToCompress.push({ text, lineLimiterValue });
                }
            });
        }
    }

    _initCompressor() {
        if (!this.textsToCompress.length) return;

        this._compressAllTexts();
        this._addControlButtons();
    }

    _compressAllTexts() {
        this.textsToCompress.forEach((item) => {
            item.text.style.setProperty("--ready-to-help-text-line-clamp", item.lineLimiterValue);
        });
    }

    _decompressAllTexts() {
        this.textsToCompress.forEach((item) => {
            item.text.style.removeProperty("--ready-to-help-text-line-clamp");
        });
    }

    _addControlButtons() {
        this.textsToCompress.forEach((item) => {
            const controlButton = document.createElement("div");

            controlButton.classList.add("lines-limiter-button");
            controlButton.innerHTML = "<span>Показать ещё</span>";
            item.text.after(controlButton);

            this.controlButtons.push(controlButton);
        });

        this._initControlButtonsListeners();
    }

    _initControlButtonsListeners() {
        if (!this.controlButtons.length) return;

        this.controlButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();

                if (button.classList.contains("active")) {
                    this._compressAllTexts();
                    this._deactivateAllControlButtons();

                    elementScrollIntoView(this.elem, {
                        behavior: "smooth",
                        block: "center",
                    });
                } else {
                    this._decompressAllTexts();
                    this._activateAllControlButtons();
                }
            });
        });
    }

    _activateAllControlButtons() {
        this.controlButtons.forEach((button) => {
            button.classList.add("active");
            button.innerHTML = "<span>Скрыть</span>";
        });
    }

    _deactivateAllControlButtons() {
        this.controlButtons.forEach((button) => {
            button.classList.remove("active");
            button.innerHTML = "<span>Показать ещё</span>";
        });
    }
}

const readyToHelp = document.querySelector(".js-ready-to-help-text-compressor-init");

if (window.mobileMedia && readyToHelp) {
    window.addEventListener("load", () => {
        new ReadyToHelpCompressor(readyToHelp);
        new MatchHeight(".ready-to-help__title");
    });
}
